import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { useLocale } from '../hooks/useLocale';
import apiClient from '../api/client';

export default function LoginPage() {
  const { token, login, fetchUser } = useAuth();
  const { t } = useLocale();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/dashboard', { replace: true });
    }
  }, [token, navigate]);

  async function handleGoogleSuccess(credentialResponse: any) {
    try {
      const res = await apiClient.post('/auth/google', {
        credential: credentialResponse.credential,
      });

      const { token: jwtToken } = res.data.data;
      login(jwtToken);
      await fetchUser();
      navigate('/dashboard', { replace: true });
    } catch (err: any) {
      console.error('Login failed:', err);
      alert(err.response?.data?.error || 'Login failed. Please try again.');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl max-w-md w-full mx-4">
        <div className="text-center mb-8">
          <div className="text-5xl mb-4">📖</div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            {t('app_name')}
          </h1>
          <p className="text-gray-600 dark:text-gray-400">{t('tagline')}</p>
        </div>

        <div className="flex justify-center">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => alert('Google login failed')}
            theme="outline"
            size="large"
            text="signin_with"
            shape="rectangular"
          />
        </div>

        <p className="text-xs text-gray-500 text-center mt-8">
          By signing in, you agree to our{' '}
          <a
            href="#/privacy"
            className="text-primary-500 hover:underline"
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
}
